// Estate zones have two-label apexes, including the fleet and preview zones.
export const zone = (hostname: string) =>
    hostname.includes(".") &&
    !hostname.endsWith(".localhost") &&
    !hostname.includes(":") &&
    !/^[0-9.]+$/.test(hostname)
        ? hostname.split(".").slice(-2).join(".")
        : "sganetwork.com";

export const collector = (hostname: string) => `https://events.${zone(hostname)}`;
